import React from 'react'
import '../styles/tree.css'

export default function Tree({inverted=false, top=false}) {

    let config = "tree-container"

    if (top) {
        if (inverted) {
            config = "tree-container-top-inverted"
        }
        else {
            config = "tree-container-top"
        }
    }

    if (inverted && !top) {
        config = "tree-container-inverted"
    }

    return (
        <div class={config}>
            <div class="trunk"/>
            <div class="branch"/>
            <div class="branch" style={{right: '30%', top: '54%', transform: 'scale(1)', rotate: '-110deg'}}/>
            <div class="branch" style={{right: '7%', top: '38%', transform: 'scale(1.5)', rotate: '-70deg'}}/>
            <div class="branch" style={{right: '22%', top: '50%', transform: 'scale(1.2)', rotate: '-85deg',
                height: '13%', width: '7%'
            }}/>

            <div class="branch" style={{right: '48%', top: '64%', transform: 'scale(0.8)',  rotate: '-50deg',
                height: '10%', width: '1%'
            }}/>
            <div class="branch" style={{right: '45%', top: '55%', transform: 'scale(0.8)', rotate: '210deg',
                height: '10%', width: '1%'
            }}/>

            <div class="branch" style={{right: '34%', top: '79%', transform: 'scale(0.8)',  rotate: '-50deg',
                height: '10%', width: '1%'
            }}/>
            <div class="branch" style={{right: '35%', top: '73.5%', transform: 'scale(0.8)', rotate: '210deg',
                height: '10%', width: '1%'
            }}/>

            <div class="branch" style={{right: '39%', top: '53%', transform: 'scale(0.6)', rotate: '189deg',
                height: '10%', width: '1%'
            }}/>

            <div class="branch" style={{right: '22%', top: '59.5%', transform: 'scale(0.8)', rotate: '-50deg',
                height: '10%', width: '1%'
            }}/>

            <div class="branch" style={{right: '20%', top: '40%', transform: 'scale(0.8)', rotate: '-50deg',
                height: '10%', width: '1%'
            }}/>    
            <div class="branch" style={{right: '20%', top: '30%', transform: 'scale(0.8)', rotate: '120deg',
                height: '10%', width: '1%'
            }}/>    
            <div class="branch" style={{right: '15%', top: '33%', transform: 'scale(0.8)', rotate: '-120deg',
                height: '10%', width: '1%'
            }}/>    

            <div class="leaves"/>
            <div class="leaves" style={{right: '43.2%', top: '60%', transform: 'scale(0.9)', rotate: '-100deg'}}/>
            <div class="leaves" style={{right: '50.5%', top: '59%', transform: 'scale(0.9)', rotate: '80deg'}}/>
            <div class="leaves" style={{right: '51%', top: '67%', transform: 'scale(0.9)', rotate: '-100deg'}}/>
            <div class="leaves" style={{right: '49.5%', top: '53%', transform: 'scale(0.9)', rotate: '-70deg'}}/>
            <div class="leaves" style={{right: '49%', top: '64%', transform: 'scale(0.7)', rotate: '20deg'}}/>

            <div class="leaves" style={{right: '35%', top: '74%', transform: 'scale(0.8)', rotate: '140deg'}}/>
            <div class="leaves" style={{right: '31.5%', top: '74%', transform: 'scale(0.8)', rotate: '-100deg'}}/>
            <div class="leaves" style={{right: '27.5%', top: '76%', transform: 'scale(0.9)', rotate: '-70deg'}}/>
            <div class="leaves" style={{right: '36.3%', top: '83%', transform: 'scale(0.8)', rotate: '60deg'}}/>
            <div class="leaves" style={{right: '33%', top: '86.5%', transform: 'scale(0.8)', rotate: '20deg'}}/>
            <div class="leaves" style={{right: '32.5%', top: '82%', transform: 'scale(0.8)', rotate: '-100deg'}}/>

            <div class="leaves" style={{right: '42%', top: '52%', transform: 'scale(0.6)', rotate: '-70deg'}}/>
            <div class="leaves" style={{right: '37%', top: '55%', transform: 'scale(0.6)', rotate: '-90deg'}}/>
            <div class="leaves" style={{right: '41.4%', top: '57%', transform: 'scale(0.6)', rotate: '-90deg'}}/>
            <div class="leaves" style={{right: '39.2%', top: '53.5%', transform: 'scale(0.5)', rotate: '-40deg'}}/>

            <div class="leaves" style={{right: '25%', top: '63%', transform: 'scale(0.8)', rotate: '60deg'}}/>
            <div class="leaves" style={{right: '21%', top: '58%', transform: 'scale(0.8)', rotate: '20deg'}}/>
            <div class="leaves" style={{right: '24.5%', top: '57.6%', transform: 'scale(0.8)', rotate: '20deg'}}/>
            <div class="leaves" style={{right: '20%', top: '63%', transform: 'scale(0.8)', rotate: '-100deg'}}/>

            <div class="leaves" style={{right: '33%', top: '51%', transform: 'scale(0.8)', rotate: '1000deg'}}/>
            <div class="leaves" style={{right: '30%', top: '47.6%', transform: 'scale(0.6)', rotate: '-20deg'}}/>

            <div class="leaves" style={{right: '15%', top: '54%', transform: 'scale(0.8)', rotate: '0deg'}}/>
            <div class="leaves" style={{right: '12%', top: '50.5%', transform: 'scale(0.8)', rotate: '30deg'}}/>
       
            <div class="leaves" style={{right: '20.5%', top: '38%', transform: 'scale(0.8)', rotate: '-60deg'}}/>
            <div class="leaves" style={{right: '23%', top: '43%', transform: 'scale(0.8)', rotate: '60deg'}}/>
            <div class="leaves" style={{right: '15%', top: '39%', transform: 'scale(0.7)', rotate: '-50deg'}}/>
            <div class="leaves" style={{right: '12%', top: '37%', transform: 'scale(0.7)', rotate: '-50deg'}}/>
            <div class="leaves" style={{right: '14%', top: '34%', transform: 'scale(0.8)', rotate: '180deg'}}/>
            <div class="leaves" style={{right: '14%', top: '27%', transform: 'scale(0.8)', rotate: '180deg'}}/>
            <div class="leaves" style={{right: '18.5%', top: '31%', transform: 'scale(0.7)', rotate: '10deg'}}/>
            <div class="leaves" style={{right: '22%', top: '33.7%', transform: 'scale(0.8)', rotate: '230deg'}}/>

        </div>
    )
}